import { Component, Input } from '@angular/core'

@Component({
  selector: 'hs-select-single-job-message',
  templateUrl: './select-single-job-message.component.html',
})
export class SelectSingleJobMessageComponent {
  message = ''
  @Input() set numberOfJobs(value: number) {
    if (value < 1) {
      this.message =
        'No job is selected. Please select atleast one job to view the panel.'
    } else if (value > 250) {
      this.message =
        'More than 250 Jobs Selected. Please select a lower amount of jobs.'
    }
  }
}
